import { render, staticRenderFns } from "./PortfolioIndex.vue?vue&type=template&id=2a29e346&scoped=true"
import script from "./PortfolioIndex.vue?vue&type=script&lang=js"
export * from "./PortfolioIndex.vue?vue&type=script&lang=js"
import style0 from "./PortfolioIndex.vue?vue&type=style&index=0&id=2a29e346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a29e346",
  null
  
)

export default component.exports